import { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";

export default function BarChartFleet({ barChartData, barMonths }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    // Clear or set error based on the presence of data
    if (!barChartData || !barMonths) {
      setError("Error: Missing required props - barChartData or barMonths.");
    } else {
      setError(null); // ✅ Clear previous error if new valid data comes in
    }
  }, [barChartData, barMonths]);

  function formatMonth(yyyymm) {
    const year = Math.floor(yyyymm / 100);
    const month = (yyyymm % 100) - 1;
    return new Date(year, month).toLocaleString("en-US", { month: "short" });
  }

  function formatDay(index) {
    return `Day${index + 1}`;
  }

  function transformBarChartData(barChartData, barMonths, isMonthly) {
    let data = [];

    if (barMonths === "month") {
      if (
        barChartData?.groupby?.buckets &&
        Array.isArray(barChartData.groupby.buckets)
      ) {
        data = barChartData.groupby.buckets;
      }
    } else if (barMonths === "day") {
      if (Array.isArray(barChartData)) {
        data = barChartData;
      }
    }

    if (!Array.isArray(data) || data.length === 0) {
      return null; // No valid data
    }

    return {
      xAxis: data.map((item, index) =>
        isMonthly ? formatMonth(item.key?.Month) : formatDay(index)
      ),
      Mileage_KMPL: data.map((item) => {
        const distance = item.A_Total_distance_Km?.value ?? 0;
        const fuelUsed = item.B_Fuel_used_in_L?.value ?? 0;
        return fuelUsed ? Number((distance / fuelUsed).toFixed(2)) : 0;
      }),
    };
  }

  const isMonthly = barMonths === "month";
  const barData = transformBarChartData(barChartData, barMonths, isMonthly);

  // ✅ Handle error or invalid data
  if (error || !barData || barData.Mileage_KMPL.length === 0) {
    return (
      <div className="error-message text-red-400 text-center p-2 text-sm items-center m-4">
        {error || "No Data Available For this ARN"}
      </div>
    );
  }

  const dummyLegend = ["Mileage (KMPL)"];

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    toolbox: {
      feature: {
        magicType: { show: true, type: ["line", "bar"] },
      },
    },
    legend: {
      data: dummyLegend,
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "1%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: barData.xAxis,
      splitLine: {
        show: false,
      },
    },
    yAxis: [
      {
        type: "value",
        name: dummyLegend[0],
        nameLocation: "center",
        nameRotate: 90,
        nameGap: 35,
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: dummyLegend[0],
        type: "bar",
        stack: "products",
        data: barData.Mileage_KMPL,
        label: {
          show: true,
          position: "inside",
          fontWeight: "bolder",
          fontSize: 15,
          rotate: barData.Mileage_KMPL.length > 6 ? 90 : 0,
        },
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
          color: "#5470C6",
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={options}
      style={{ height: 300, width: "100%" }}
      className="pb-8"
    />
  );
}
